/* ============================================================
   VENOM PROTOTYPING — THEME JAVASCRIPT
   Handles: mobile nav, gallery, variants, AJAX cart, tabs
   ============================================================ */

(function () {
  'use strict';

  /* ── HERO BACKGROUND ROTATOR ────────────────────────────── */
  const heroBgs = document.querySelectorAll('.hero-bg');
  if (heroBgs.length > 1) {
    let current = 0;
    setInterval(function () {
      heroBgs[current].classList.remove('active');
      current = (current + 1) % heroBgs.length;
      heroBgs[current].classList.add('active');
    }, 5000);
  }

  /* ── NAV SEARCH INLINE ───────────────────────────────────── */
  const searchToggle = document.querySelector('.nav-search-toggle');
  const searchForm   = document.querySelector('.nav-search-form');
  const searchInput  = document.querySelector('.nav-search-input');

  if (searchToggle && searchForm) {
    searchToggle.addEventListener('click', function () {
      const isOpen = searchForm.classList.contains('open');
      if (isOpen) {
        if (searchInput && searchInput.value.trim()) {
          searchForm.submit();
        } else {
          searchForm.classList.remove('open');
        }
      } else {
        searchForm.classList.add('open');
        if (searchInput) searchInput.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!searchForm.contains(e.target)) {
        searchForm.classList.remove('open');
      }
    });
  }

  /* ── MOBILE MENU ─────────────────────────────────────────── */
  const mobileToggle = document.querySelector('.nav-mobile-toggle');
  const mobileMenu   = document.querySelector('.mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ── GALLERY THUMBNAILS ──────────────────────────────────── */
  const thumbs   = document.querySelectorAll('.gallery-thumb');
  const mainImg  = document.getElementById('gallery-main-img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ── PRODUCT VARIANT SELECTOR ────────────────────────────── */
  const variantSelect  = document.getElementById('variant-select');
  const variantBtns    = document.querySelectorAll('.variant-btn');
  const priceDisplay   = document.getElementById('product-price');
  const atcBtn         = document.getElementById('atc-btn');

  if (variantSelect && variantBtns.length > 0 && window.productData) {
    const product = window.productData;

    // Track current option selections
    const currentOptions = Array.from(
      document.querySelectorAll('.variant-options')
    ).map(function (group) {
      const active = group.querySelector('.variant-btn.selected');
      return active ? active.dataset.value : null;
    });

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const optionIndex = parseInt(btn.dataset.optionIndex, 10);

        // Deselect siblings in same option group
        document
          .querySelectorAll(`.variant-btn[data-option-index="${optionIndex}"]`)
          .forEach(function (b) { b.classList.remove('selected'); });

        btn.classList.add('selected');
        currentOptions[optionIndex] = btn.dataset.value;

        // Find matching variant
        const matched = product.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return currentOptions[i] === null || opt === currentOptions[i];
          });
        });

        if (matched) {
          // Update hidden select so the form submits the right ID
          variantSelect.value = matched.id;

          // Update price display
          if (priceDisplay) {
            priceDisplay.textContent = formatMoney(matched.price);
          }

          // Update ATC button
          if (atcBtn) {
            if (matched.available) {
              atcBtn.disabled = false;
              atcBtn.textContent = 'Add to Cart';
            } else {
              atcBtn.disabled = true;
              atcBtn.textContent = 'Sold Out';
            }
          }

          // Update URL without reload
          const url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ── AJAX ADD TO CART ────────────────────────────────────── */
  const productForm = document.getElementById('product-form');

  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(productForm);
      const variantId = formData.get('id');

      if (!variantId) return;

      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.textContent = 'Adding…';
        submitBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function (item) {
          showToast('✓ ' + item.product_title + ' added to cart', 'success');
          updateCartCount();
        })
        .catch(function () {
          showToast('Could not add item. Please try again.', 'error');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        });
    });
  }

  /* Quick-add + buttons in listing grid */
  document.querySelectorAll('.add-btn[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          showToast('✓ Added to cart', 'success');
          updateCartCount();
        })
        .catch(function () {
          // If product has variants, navigate to product page instead
          const card = btn.closest('.product-card');
          if (card) {
            const link = card.querySelector('a');
            if (link) window.location = link.href;
          }
        });
    });
  });

  /* ── DESCRIPTION TABS ────────────────────────────────────── */
  const descTabs = document.querySelectorAll('.desc-tab');

  descTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const targetId = 'tab-' + tab.dataset.tab;

      descTabs.forEach(function (t) { t.classList.remove('active'); });
      document.querySelectorAll('.desc-content').forEach(function (panel) {
        panel.hidden = true;
      });

      tab.classList.add('active');
      const target = document.getElementById(targetId);
      if (target) target.hidden = false;
    });
  });

  /* ── FILTER TABS (collection page, JS fallback) ──────────── */
  // Filter tabs navigate to collection URLs natively via <a> tags
  // This just handles the active visual state on load
  const filterTabs = document.querySelectorAll('.filter-tab');
  filterTabs.forEach(function (tab) {
    if (tab.href && window.location.pathname.startsWith(new URL(tab.href).pathname)) {
      tab.classList.add('active');
    }
  });

  /* ── CART COUNT UPDATE ───────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const countEl = document.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (countEl) {
            countEl.textContent = cart.item_count;
          } else {
            const cartIcon = document.querySelector('.nav-cart');
            if (cartIcon) {
              const span = document.createElement('span');
              span.className = 'cart-count';
              span.textContent = cart.item_count;
              cartIcon.appendChild(span);
            }
          }
        }
      });
  }

  /* ── TOAST HELPER ────────────────────────────────────────── */
  function showToast(message, type) {
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'toast ' + (type || '');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('show');
      });
    });

    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  }

  /* ── MONEY FORMATTER ─────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── NAV SCROLL BEHAVIOR ─────────────────────────────────── */
  // Already handled by CSS backdrop-filter; no JS needed.

})();
